angular.module('zc.projects')

.directive 'countryCodeSelector', ($modal, $translate, Image, lib) ->
  restrict: 'E'
  scope:
    countryCodes: '='
    disabled: '='
  template: """
    <select
      class="multi-select"
      style="width: 100%"
      ng-model="countryCodes"
      name="country_code_selector"
      multiple="true">
    </select>
  """
  link: (scope, element, attrs) ->
    element = element.children('select')
    if scope.disabled in ['true', true]
      availableCountryCodes = scope.countryCodes
      element.prop('disabled', true)
    else
      availableCountryCodes = scope.$parent.allCountryCodes

    data = _.map availableCountryCodes, (countryCode) -> {
      id: countryCode,
      text: countryCode,
      selected: _.includes(scope.countryCodes, countryCode)
    }

    element.select2({
      data: data
    })



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.segments/country_code_selector.coffee